<template>
  <div class="wrapper">
    <b-form>
      <b-form-group
        id="input-name-group"
        label="Nom :"
        label-for="input-name"
      >
        <b-form-input
          id="input-name"
          v-model="profile.nom"
          type="text"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-surname-group"
        label="Prénom :"
        label-for="input-surname"
      >
        <b-form-input
          id="input-surname"
          v-model="profile.prenom"
          type="text"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-avatar-group"
        label="Avatar :"
        label-for="input-surname"
      >
        <b-form-file
          v-model="avatar.image"
          accept="image/*"
          placeholder="Choisissez une image..."></b-form-file>
        
        <div class="avatar-wrapper">
          <Avatar :user="profile"/>
        </div>
      </b-form-group>
      
      <hr>
      
      <input type="text" id="username" name="username" style="display:none" value="azodkazd"/>

      <b-form-group
        id="input-oldpass-group"
        label="Ancien mot de passe :"
        label-for="input-oldpass"
      >
        <b-form-input
          id="input-oldpass"
          v-model="password.old"
          type="password"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-newpass1-group"
        label="Nouveau mot de passe :"
        label-for="input-newpass1"
      >
        <b-form-input
          id="input-newpass1"
          v-model="password.new"
          type="password"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-newpass2-group"
        label="Confirmer le nouveau mot de passe :"
        label-for="input-newpass2"
      >
        <b-form-input
          id="input-newpass2"
          v-model="password.confirm"
          type="password"
          required
        ></b-form-input>
      </b-form-group>

      <hr>
      <b-form-checkbox
        id="checkbox-weeklymail"
        v-model="profile.weekly_mail"
        name="checkbox-weeklymail"
      >
        Je souhaite recevoir un rappel chaque semaine des soirées à venir
      </b-form-checkbox>

      <hr>
      
      <b-button @click="updateStep1" variant="primary">Modifier</b-button>
      <b-button @click="deleteAccount" variant="danger" class="float-right">Supprimer le compte</b-button>
    </b-form>
    
    <b-modal v-model="okDeleteModal" title="Suppression du compte" @ok="deleteAccountConfirmed" >
      <div>
        Attention, vous allez supprimer votre compte et toutes les données associées, il ne pourra être recréé que par l'administration du site. Confirmez vous la suppression ?
      </div>
      <template slot="modal-cancel">Annuler</template>
      <template slot="modal-ok">Comfirmer la suppression</template>
    </b-modal>
    <b-modal v-model="errorDeleteModal" title="Oups !!!" ok-only>
      <div>
        Impossible de supprimer votre compte. N'hésitez pas à en parler aux membres de l'association chargés d'administrer ce site.
      </div>
    </b-modal>
    <b-modal v-model="passwordErrorModal" title="Mot de passe incorrecte" ok-only @ok="updateStep2">
      <div>
        Le nouveau mot de passe et sa confirmation ne sont pas identiques.
      </div>
    </b-modal>
    <b-modal v-model="passwordRefusedModal" title="Mot de passe incorrecte" ok-only @ok="updateStep2">
      <div>
        L'ancien mot de passe est invalide, la modification n'a pas été réalisée.
      </div>
    </b-modal>
    
    <b-modal v-model="avatarErrorModal" title="Mot de passe incorrecte" ok-only @ok="updateStep3">
      <div>
        Erreur, impossible de modifier l'avatar.
      </div>
    </b-modal>
    
    <b-modal v-model="dataOkModal" title="Mot de passe incorrecte" ok-only>
      <div>
        Modifications terminées.
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import Avatar from '@/components/parts/Avatar'
export default {
  name: 'ProfileView',
  components:{
    Avatar,
  },
  data: function(){
    return {
      profile: {},
      password:{},
      avatar:{},
      okDeleteModal: false,
      errorDeleteModal: false,
      passwordErrorModal: false,
      passwordRefusedModal: false,
      avatarErrorModal: false,
      dataOkModal: false,
    }
  },
  created: function(){
    Vue.$backend.getData().then(res => {
      this.profile = res
      this.profile.weekly_mail = this.profile.weekly_mail === 1 ? true : false
    })
  },
  methods: {
    updateStep1() {
      if(this.password.old){
        if(this.password.new === this.password.confirm){
          Vue.$backend.changePassword(this.password.old, this.password.new).then(
            () => {
              this.password = {}
              this.updateStep2()
            }, () => {
              this.passwordRefusedModal = true
            }
          )
        } else {
          this.passwordErrorModal = true
          return;
        }
      } else {
        this.updateStep2()
      }
    },
    updateStep2(){
      if(this.avatar.image){
        Vue.$backend.changeAvatar(this.avatar.image)
        .then(() => {
          this.updateStep3()
        }, () => {
          this.avatarErrorModal = true
        })
      } else {
        this.updateStep3()
      }
    },
    updateStep3(){
      this.profile.weekly_mail = this.profile.weekly_mail ? 1 : 0
      Vue.$backend.updateData(this.profile)
      .then(() => {
        this.profile.weekly_mail = this.profile.weekly_mail === 1 ? true : false
        this.dataOkModal = true
      })
    },
    deleteAccount() {
      this.okDeleteModal = true
    },
    deleteAccountConfirmed(){
      Vue.$backend.deleteAccount()
      .then(() => {
        this.$forceUpdate()
        this.$router.push('/')
      }, () => {
        this.errorDeleteModal = true
      });
    }
  },
}
</script>


<style scoped>

.avatar-wrapper{
  position: relative;
  left: 61px;
  top: -70px;
  width: 0px;
}

.wrapper{
  margin: 20px;
}

</style>
